<script lang="ts" setup>
import AdministrationTable from "@/data-views/tables/administration/AdministrationTable.vue";
definePage({
  meta: {
    action: "read",
    subject: "AdministrationOverview",
  },
});
</script>

<template>
  <VRow class="match-height">
    <VCol cols="12">
      <AdministrationTable />
    </VCol>
  </VRow>
</template>
